import { ChiroUpAPI } from '@chiroup/client-core/functions/ChiroUpAPI';

/**
 * Each total carries both event volume (`events`) and the unique-clinic
 * reach (`clinics`). UI defaults to `clinics` because that's the more
 * meaningful answer to "how many trial clinics did this affect"; the raw
 * count is preserved alongside for product to grow into later.
 */
export type TrialAnalyticsTotal = {
  events: number;
  clinics: number;
};

export type TrialAnalyticsTotals = {
  homeViews: TrialAnalyticsTotal;
  tourStarts: TrialAnalyticsTotal;
  tourCompletions: TrialAnalyticsTotal;
  tourSkips: TrialAnalyticsTotal;
  personalizeOpens: TrialAnalyticsTotal;
  personalizeSaves: TrialAnalyticsTotal;
};

export type TrialAnalyticsCard = {
  cardId: string | null;
  clicks: number;
  distinctClinics: number;
};

export type TrialAnalyticsTourStep = {
  stepIndex: number;
  stepKey: string | null;
  distinctClinics: number;
  views: number;
};

export type TrialAnalyticsTour = {
  tourId: string;
  started: number;
  completed: number;
  skipped: number;
  steps: TrialAnalyticsTourStep[];
};

export type TrialAnalyticsChecklistRow = {
  rowId: string | null;
  clicks: number;
  distinctClinics: number;
};

/** One-time "What are you looking to explore?" answers, per stored value.
 *  `users` (not events) is the unit — the answer is per-user and write-once. */
export type TrialAnalyticsIntentRow = {
  intent: string | null;
  users: number;
  distinctClinics: number;
};

export type TrialAnalyticsResponse = {
  windowDays: number;
  totals: TrialAnalyticsTotals;
  cards: TrialAnalyticsCard[];
  tours: TrialAnalyticsTour[];
  checklist: TrialAnalyticsChecklistRow[];
  intent: TrialAnalyticsIntentRow[];
};

const trialAnalyticsService = () => {
  const get = async (windowDays = 30): Promise<TrialAnalyticsResponse> => {
    return ChiroUpAPI.get('api', `/trial/analytics?windowDays=${windowDays}`, {});
  };

  return { get };
};

export default trialAnalyticsService();
